import * as THREE from 'three';
import UtilSP from 'SATPROF_UTILS/UtilSP';

export default class House_grp  extends THREE.Group{
   
    /* 
    */
    private W = 5; // House width
    private D = 8; // House depth
    private H = 2 * 3.5; /// Wall height to eave
    private P = 3.5; // Peak height above H
    private OHX = 1; // Roof overhang
    private tempObj:THREE.Group;
    private wallMatl:THREE.MeshPhongMaterial;
    private roofMatl:THREE.MeshPhongMaterial;
    private  walls_m:THREE.Mesh;
    private  endWall1_m:THREE.Mesh;
    private  endWall2_m:THREE.Mesh;
    private endWall1_g:THREE.ShapeGeometry;
    private endWall2_g:THREE.ShapeGeometry;
    private plate_g:THREE.ExtrudeGeometry;
    private sideWall1_g:THREE.PlaneGeometry;
    private sideWall1_m:THREE.Mesh;
    private sideWall2_g:THREE.PlaneGeometry;
    private sideWall2_m:THREE.Mesh;
    private roof_g:THREE.PlaneGeometry;
    private roof1_m:THREE.Mesh
    private roof2_m:THREE.Mesh;
    private _wallColor:string = "gray";
    private _roofColor:string = "white";

    constructor(){
        super();
        //console.log("In House_grp constructor...")
        this.createObject();
    }
    
    //let axesHelper = new THREE.AxesHelper( 5 );  
    private createObject(){
        this.wallMatl = new THREE.MeshPhongMaterial( { color:this._wallColor, side: THREE.DoubleSide } );
        this.roofMatl = new THREE.MeshPhongMaterial( { color:this._roofColor, side: THREE.DoubleSide } );

        this.tempObj = new THREE.Group();
        this.add(this.tempObj);   
        this.refresh();
    }

    public refresh(){    
        this.tempObj.remove(this.endWall1_m);
        this.tempObj.remove(this.endWall2_m);
        this.tempObj.remove(this.sideWall1_m);
        this.tempObj.remove(this.sideWall2_m);
        this.tempObj.remove(this.roof1_m);
        this.tempObj.remove(this.roof2_m);
        
        let endWall_s:THREE.Shape = new THREE.Shape();
        endWall_s.moveTo(-this.W/2,0);
        endWall_s.lineTo(-this.W/2, this.H);
        endWall_s.lineTo(0, this.H+this.P);
        endWall_s.lineTo(this.W/2, this.H);
        endWall_s.lineTo(this.W/2,0);
        endWall_s.lineTo(-this.W/2,0);

        this.endWall1_g = new THREE.ShapeGeometry(endWall_s);
        this.endWall1_m = new THREE.Mesh( this.endWall1_g, this.wallMatl ) ;
        this.endWall1_m.position.z = this.D/2;

        this.endWall2_g = new THREE.ShapeGeometry(endWall_s);
        this.endWall2_m = new THREE.Mesh( this.endWall2_g, this.wallMatl ) ;
        this.endWall2_m.position.z = -this.D/2;
        this.endWall2_m.rotation.y = Math.PI;

        this.sideWall1_g = new THREE.PlaneGeometry(this.D, this.H);
        this.sideWall1_m = new THREE.Mesh( this.sideWall1_g, this.wallMatl ) ; 
        this.sideWall1_m.rotation.y = Math.PI/2;
        this.sideWall1_m.position.y = this.H/2;   
        this.sideWall1_m.position.x = this.W/2;

        this.sideWall2_g = new THREE.PlaneGeometry(this.D, this.H);
        this.sideWall2_m = new THREE.Mesh( this.sideWall2_g, this.wallMatl ) ; 
        this.sideWall2_m.rotation.y = -Math.PI/2;
        this.sideWall2_m.position.y = this.H/2;   
        this.sideWall2_m.position.x = -this.W/2;

        let WR:number = this.OHX + Math.sqrt( this.P**2 + (this.W/2)**2) + this.OHX;
        let theta = Math.atan2( this.P, this.W/2);
        let DR:number = this.D + 2*this.OHX;
        this.roof_g = new THREE.PlaneGeometry(WR, DR);
        this.roof1_m = new THREE.Mesh( this.roof_g, this.roofMatl ) ;
        this.roof1_m.rotation.y = -theta;
        this.roof1_m.rotation.x = -Math.PI/2;
        this.roof1_m.position.y = this.H + this.P - WR* Math.sin(theta)/2;
        this.roof1_m.position.x = - WR* Math.cos(theta)/2;

        this.roof2_m = new THREE.Mesh( this.roof_g, this.roofMatl ) ;
        this.roof2_m.rotation.y = theta;
        this.roof2_m.rotation.x = -Math.PI/2;
        this.roof2_m.position.y = this.roof1_m.position.y;
        this.roof2_m.position.x = -this.roof1_m.position.x;

        this.tempObj.add(this.endWall1_m);
        this.tempObj.add(this.endWall2_m);
        this.tempObj.add(this.sideWall1_m);
        this.tempObj.add(this.sideWall2_m);
        this.tempObj.add(this.roof1_m);
        this.tempObj.add(this.roof2_m);

        this.tempObj.position.x = 0;
        this.tempObj.position.y = 0;

    }

	public set houseDepth(v){   
        this.D = v;	    
        this.refresh();		
    }
	public get houseDepth(){   
        return this.D;		
    }
	public set houseWidth(v){   
        this.W = v;	    
        this.refresh();		
    }
	public get houseWidth(){   
        return this.D;		
    } 
	public set houseHeight(v){   
        this.H = v;	    
        this.refresh();		
    }
	public get houseHeight(){   
        return this.H;		
    } 
	public set housePeakHeight(v){   
        this.P = v;	    
        this.refresh();		
    }
	public get housePeakHeight(){   
        return this.P;		
    }      
 	public set overhang(v){   
        this.OHX = v;	    
        this.refresh();		
    }
	public get overhang(){   
        return this.OHX;		
    }           
    public set wallColor(val:string){
        this._wallColor = val;
        this.wallMatl = new THREE.MeshPhongMaterial( { color:this._wallColor } );
        this.endWall1_m.material = this.wallMatl;
        this.endWall2_m.material = this.wallMatl;
        this.sideWall1_m.material = this.wallMatl;
        this.sideWall2_m.material = this.wallMatl;
    }
    public get wallColor(){
        return this._wallColor;
    }
    public set roofColor(val:string){
        this._roofColor = val;
        this.roofMatl = new THREE.MeshPhongMaterial( { color:this._roofColor, side: THREE.DoubleSide } );
        this.roof1_m.material = this.roofMatl;
        this.roof2_m.material = this.roofMatl;
     }
    public get roofColor(){
        return this._roofColor;
    }
}


